/*********************/
/******** TAB ********/
/*********************/

declare var gsap: any;

interface ReferenceElement<T> {
    selector?: string;
    target?: T | null | undefined;
}

interface TabConfig {
    on?: TabEvents;
}

interface TabClasses {
    main: string;
    item: string;
    article: string;
}

interface TabEvents {
    [event: string]: (e: any) => void;
}

/**
 * @param {string} classes // Clases principales (contenedor, tabs, articles)
 * @param {ReferenceElement} tabWrapper // Contenedor principal
 * @param {string} activeTab // Tab activado
 * @param {TabEvents} events // Eventos
 */
export default class Tab {
    classes: TabClasses;
    tabWrapper: ReferenceElement<HTMLElement>;
    activeTab: string = '';
    events: TabEvents | undefined;

    constructor(prefixProject: string, config?: TabConfig) {
        this.classes = { main: `${prefixProject}-tab`, item: `${prefixProject}-tab__item`, article: `${prefixProject}-tab__article` }
        this.tabWrapper = { selector: `.${this.classes.main}`, target: document.querySelector(`.${this.classes.main}`) as HTMLElement };
        this.events = config?.on;
        this.init();
    }

    init() {
        this.activateDefault()
        this.setHandlerEvent()
    }

    activateDefault(): void {
        let { target } = this.tabWrapper
        let { item, article } = this.classes

        if (!document.querySelector(`.${item}--active`)) {
            let headerTab = document.querySelector(`.${item}`) as HTMLElement;
            this.disableSection()
            this.enableSection(headerTab?.dataset.tab)
        }
        else {
            let activeItem = document.querySelector(`.${item}--active`) as HTMLElement
            this.activeTab = activeItem?.dataset.tab
        }

        this.events?.initialize?.({
            nwSection: { name: this.activeTab, target: target?.querySelector(`.${article}[data-tab=${this.activeTab}]`) }
        })
    }

    setHandlerEvent(): void {
        let { target } = this.tabWrapper
        let { main, item, article } = this.classes

        target?.addEventListener('click', (e) => {
            let clickedElm = e.target as HTMLElement

            if (clickedElm.closest(`.${item}`)) {
                let activator = clickedElm.closest(`.${item}`) as HTMLElement;
                let dataTab = activator.dataset.tab
                let oldTab = this.activeTab

                if (this.activeTab != dataTab) {
                    this.disableSection()
                    this.enableSection(dataTab)

                    this.events?.activateSection?.({
                        oldSection: { name: oldTab, target: target?.querySelector(`.${article}[data-tab=${oldTab}]`) },
                        nwSection: { name: this.activeTab, target: target?.querySelector(`.${article}[data-tab=${this.activeTab}]`) }
                    })
                }
            }
        })
    }

    enableSection(nwTab: string | undefined): void {
        if (typeof nwTab == 'string') {
            let { target } = this.tabWrapper
            let { item, article } = this.classes

            this.activeTab = nwTab;
            target?.querySelector(`.${item}[data-tab=${nwTab}]`)?.classList.add(`${item}--active`)
            target?.querySelector(`.${article}[data-tab=${nwTab}]`)?.classList.add(`${article}--active`)
        }
    }

    disableSection(): void {
        let { target } = this.tabWrapper
        let { item, article } = this.classes

        target?.querySelector(`.${item}--active`)?.classList.remove(`${item}--active`)
        target?.querySelector(`.${article}--active`)?.classList.remove(`${article}--active`)
    }
}